module.exports = __webpack_public_path__ + "static/media/main idea.790282be.mp3";